import {
  List,
  TextField,
  EditButton,
  ShowButton,
  Datagrid,
  SimpleList,
  TopToolbar,
  CreateButton,
  DateField,
} from "react-admin";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import permissions from "app/permissions";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";
import { CampExporter } from "./XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";

const ListCamps = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={CampExporter} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Лагери"
      sx={settings.style.expandStyle}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateCamps)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Начало на регистрация",
                    value: (
                      <DateField
                        locales="bg-BG"
                        source="registrationStart"
                        label="Начало на регистрация"
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Край на регистрация",
                    value: (
                      <DateField
                        locales="bg-BG"
                        source="registrationEnd"
                        label="Край на регистрация"
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Начална дата",
                    value: (
                      <DateField
                        locales="bg-BG"
                        source="startDate"
                        label="Начална дата"
                      />
                    ),
                  },
                  {
                    label: "Крайна дата",
                    value: (
                      <DateField
                        locales="bg-BG"
                        source="endDate"
                        label="Крайна дата"
                      />
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              {checkPermission(userPermissions, permissions.canUpdateCamps) && <EditButton label="" />}
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
          sx={settings.style.firstExpandIconDatagrid}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          <DateField
            locales="bg-BG"
            source="registrationStart"
            label="Начало на регистрация"
            sortable={false}
          />
          <DateField
            locales="bg-BG"
            source="registrationEnd"
            label="Край на регистрация"
            sortable={false}
          />
          <DateField
            locales="bg-BG"
            source="startDate"
            label="Начална дата"
            sortable={false}
          />
          <DateField
            locales="bg-BG"
            source="endDate"
            label="Крайна дата"
            sortable={false}
          />
          {checkPermission(userPermissions, permissions.canUpdateCamps) && <EditButton />}
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};
export default ListCamps;
